import React, { useEffect } from 'react';

import { Box } from '@chakra-ui/react';
import { PlainTextHeader } from 'Deer/components/HeaderComponents/PlainTextHeader';
import { getUserL2Access } from 'Deer/helpers/getUserAccess';

import { sendPageViewEvent } from 'constants/mixpanelHelper';

import { FeedbackOverview } from './cards/FeedbackOverview/FeedbackOverview';
import { GoalsOverview } from './cards/GoalsOverview/GoalsOverview';
import OneOnOneOverview from './cards/OneOnOneOverview/OneOnOneOverview';
import { ReviewsOverview } from './cards/ReviewsOverview/ReviewsOverview';

const modules = [
  { check: () => getUserL2Access().hasReviewAccess, component: <ReviewsOverview /> },
  { check: () => getUserL2Access().hasGoalAccess, component: <GoalsOverview /> },
  {
    check: () => getUserL2Access().hasFeedbackAccess,
    component: <FeedbackOverview />,
  },
  { check: () => getUserL2Access().hasOneOnOneAccess, component: <OneOnOneOverview /> },
];

const MyDataOverview = () => {
  useEffect(() => {
    sendPageViewEvent({
      eventProperties: {
        page: 'Me-overview',
      },
    });
  }, []);

  return (
    <>
      <PlainTextHeader bold mb={1}>
        My overview
      </PlainTextHeader>
      {modules?.map(
        ({ check, component }, index) =>
          check() && (
            // eslint-disable-next-line react/no-array-index-key
            <Box mb={3} key={index}>
              {component}
            </Box>
          )
      )}
    </>
  );
};

export default MyDataOverview;
